module.exports = [
  { name: "waterford", host: "https://api.waterford.sensoreal.com.au" },
  { name: "carolina", host: "https://api.carolina.sensoreal.com.au" },
  { name: "covella", host: "https://api.covella.sensoreal.com.au" },
  { name: "bloomdale", host: "https://api.bloomdale.sensoreal.com.au" },
  { name: "harmony", host: "https://api.harmony.sensoreal.com.au" },
  { name: "savana", host: "https://api.savana.sensoreal.com.au" },
  { name: "skyridge", host: "https://api.skyridge.sensoreal.com.au" },
  {
    name: "brentwood forest",
    host: "https://api.brentwoodforest.sensoreal.com.au",
  },
  { name: "riverlea", host: "https://api.riverlea.sensoreal.com.au" },
  { name: "amara", host: "https://api.amara.sensoreal.com.au" },
  {
    name: "project vista",
    host: "https://api.projectvista.sensoreal.com.au",
  },
  { name: "springwood", host: "https://api.springwood.sensoreal.com.au" },
  { name: "silver to sea", host: "https://api.silvertosea.sensoreal.com.au" },
  {
    name: "chambers reserve",
    host: "https://api.chambersreserve.sensoreal.com.au",
  },
  {
    name: "vantage bloomdale",
    host: "https://api.vantagebloomdale.sensoreal.com.au",
  },
  {
    name: "vantage harmony",
    host: "https://api.vantageharmony.sensoreal.com.au",
  },
  { name: "elan", host: "https://api.elan.sensoreal.com.au" },
  {
    name: "vantage hervey bay",
    host: "https://api.herveybay.sensoreal.com.au",
  },
  { name: "st james", host: "https://api.stjames.sensoreal.com.au" },
  { name: "ebayya", host: "https://api.ebayya.sensoreal.com.au" },
  // { name: "murifa", host: "https://api.murifa.sensoreal.com.au" }, to add back later if required
  // { name: "thuraya", host: "https://api.thuraya.sensoreal.com.au" }, to add back later if required
  { name: "al mouj", webx: true, host: "https://api.almouj.sensoreal.app" },
  { name: "forest reach", host: "https://api.forestreach.sensoreal.app" },
  { name: "nhc selector", host: "https://api.nhcselector.sensoreal.app" },
  {
    name: "al fursan selector",
    host: "https://api.alfursanselector.sensoreal.app",
  },
  {
    name: "al fursan ebayya quarters 1",
    host: "https://api.alfursanebayyaquarters1.sensoreal.app",
  },
  {
    name: "al fursan ebayya quarters 2",
    host: "https://api.alfursanebayyaquarters2.sensoreal.app",
  },
  {
    name: "al fursan ebayya heights 1",
    host: "https://api.alfursanebayyaheights1.sensoreal.app",
  },
  {
    name: "al fursan ebayya elite 1",
    host: "https://api.alfursanebayyaelite1.sensoreal.app",
  },
  {
    name: "madeline",
    host: "https://api.madeline.sensoreal.app",
  },
  {
    name: "sadayem selector",
    host: "https://api.sadayemselector.sensoreal.app",
  },
  {
    name: "sadayem residences",
    host: "https://api.sadayemresidences.sensoreal.app",
  },
  {
    name: "sadayem thuraya",
    host: "https://api.sadayemthuraya.sensoreal.app",
  },
  {
    name: "khuzam selector",
    host: "https://api.khuzamselector.sensoreal.app",
  },
  {
    name: "khuzam murifa",
    host: "https://api.khuzammurifa.sensoreal.app",
  },
  {
    name: "khuzam park residence",
    host: "https://api.khuzamparkresidence.sensoreal.app",
    alerts: false,
  },
  {
    name: "vantage lilywood",
    host: "https://api.vantagelilywood.sensoreal.app",
  },
  {
    name: "vantage logan reserve",
    host: "https://api.vantageloganreserve.sensoreal.app",
  },
  {
    name: "banyan hill",
    webx: true, host: "https://api.banyanhill.sensoreal.app",
  },
  {
    name: "newenham",
    host: "https://api.newenham.sensoreal.app",
  },
  {
    name: "lyndarum north",
    host: "https://api.lyndarumnorth.sensoreal.app",
  },
  { name: "somerford", host: "https://api.somerford.sensoreal.app" },
  { name: "rosella rise", host: "https://api.rosellarise.sensoreal.app" },
  { name: "defence demo", host: "https://api.defencedemo.sensoreal.app" },
  { name: "whiterock", webx: true, host: "https://api.whiterock.sensoreal.app" },
  { name: "senses", host: "https://api.senses.sensoreal.app" },
  { name: "north harbour", webx: true, host: "https://api.northharbour.sensoreal.app" },
  { name: "evergreen", host: "https://api.evergreen.sensoreal.app" },
  { name: "murdoch waters", host: "https://api.murdochwaters.sensoreal.app" },
  {
    name: "al irfan rawdh residences",
    host: "https://api.alirfanrawdh.sensoreal.app",
  },
  {
    name: "al irfan - selector (madinat)",
    webx: true, host: "https://api.madinat.sensoreal.app",
  },
  { name: "sanctuary rise", host: "https://api.sanctuaryrise.sensoreal.app" },
  { name: "al khobar", webx: true, host: "https://api.sdc-alkhobar.sensoreal.app" },
  { name: "ode south bank", webx: true, host: "https://api.odesouthbank.sensoreal.app" },
  { name: "arven", host: "https://api.arven.sensoreal.app" },
  { name: "serenade", host: "https://api.serenade.sensoreal.app" },
  { name: "sdc al madinah", host: "https://api.sdc-almadinah.sensoreal.app" },
];
